import { Component } from "react";
import { getCPFYears } from "../../../../managers/common/CommonUtil";
import RouteManager from "../../../../managers/RouteManager";
import MYReport from "./MYReport";
import { MY_REPORTS } from "./MYReportConstants";

export default class SOCSOBorang8A extends Component {
    data = {
        title: 'SOCSO Borang 8A',
        yearOptions: getCPFYears(),
        actionBtn: ['downloadForm','downloadTextFile'],
        fields: ['year','month'],
        fileName:'Borang8A',
        defaultValues:{
            year: new Date().getFullYear(),
            month: new Date().getMonth()+1,
            formType: MY_REPORTS.BORANG8A
        }
    }
    constructor(props) {
        super(props)
        RouteManager.setPresenter(this);
    }
    onButtonClick(btn) {

    }
    render() {
        return(
            <MYReport data={this.data} onButtonClick={(btn)=>{this.onButtonClick(btn)}}/>
        )
    }
}